export const links = [
  { id: '1', to: '#home', title: 'Home' },
  { id: '2', to: '#about', title: 'About' },
  { id: '3', to: '#services', title: 'Services' },
  { id: '4', to: '#portfolio', title: 'Portfolio' },
  { id: '5', to: '#contact', title: 'Contact' },
];

export default 'NavbarData';
